import React from 'react'
import Header from './header'
import Footer from './Footer'

function Pricing() {
  return (
    <div>
        <Header/>
            <section className='pricing-page'>
                 <div className="container  pricing-section">
      <h1 className="fw-bold text-center">Plans and Pricing</h1>
      <p className="text-muted text-center">Receive unlimited credits when you pay yearly, and save on your plan.</p>

      <div className="d-inline-flex my-4 switch-toggle">
        <button className="btn btn-outline-secondary active">Monthly</button>
        <button className="btn btn-outline-secondary">Annual <span className="badge bg-light text-dark ms-1">Save 35%</span></button>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-4">
          <div className="card pricing-card h-100">
            <div className="card-body">
              <h5 className="text-muted">Free</h5>
              <h2 className="fw-bold">$0</h2>
              <p className="text-muted">Per user/month, billed annually</p>
              <ul className="list-unstyled">
                <li>✔ Free e-mail alerts</li>
                <li>✔ 3-minute checks</li>
                <li>✔ Automatic data enrichment</li>
                <li>✔ 10 monitors</li>
                <li>✔ Up to 3 seats</li>
              </ul>
              <button className="btn btn-outline-dark w-100">Get started for free</button>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card pricing-card popular h-100">
            <div className="card-body">
              <h5 className="d-flex justify-content-between">
                <span>Pro</span>
                <span className="badge bg-warning text-dark">🔥 Popular</span>
              </h5>
              <h2 className="fw-bold">$85</h2>
              <p className="text-muted">Per user/month, billed annually</p>
              <ul className="list-unstyled">
                <li>✔ Unlimited phone calls</li>
                <li>✔ 30 second checks</li>
                <li>✔ Single-user account</li>
                <li>✔ 20 monitors</li>
                <li>✔ Up to 6 seats</li>
              </ul>
              <button className="btn btn-dark w-100">Get started with Pro</button>
            </div>
          </div>
        </div>


        <div className="col-md-4">
          <div className="card pricing-card enterprise h-100">
            <div className="card-body">
              <h5>Enterprise</h5>
              <h2 className="fw-bold">Custom</h2>
              <p>Per user/month, billed annually</p>
              <ul className="list-unstyled">
                <li>✔ Everything in Pro</li>
                <li>✔ Up to 5 team members</li>
                <li>✔ 100 monitors</li>
                <li>✔ 15 status pages</li>
                <li>✔ 200+ integrations</li>
              </ul>
              <button className="btn btn-light w-100">Get started with Enterprise</button>
            </div>
          </div>
        </div>
      </div>
    </div>
            </section>
            <Footer/>
    </div>

  )
}
export default Pricing
